import React, {
  useState,
  useRef,
  useEffect,
  useLayoutEffect,
  useContext,
} from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import styled from 'styled-components';
import GlobalStyles from './components/globals/GlobalStyles';
import SliderPageRightPane from './pages/SliderPageRightPane';
import ExhibitorContext from './context/exhibitorContext';
import Register from './components/registrationForm/Register';
import LoginForm from './components/registrationForm/LoginForm';
import SliderPage from './pages/SliderPage';
import expoHallAPI from './api/expoHallAPI';
import RegistrationForm from './components/registrationForm/RegistrationForm';
import { Provider as UserProvider } from './context/UserContext';
import { Provider as AttendantProvider } from './context/AttendantContext';
import { Provider as ClientProvider } from './context/ClientContext';
import {
  Context as SocketContext,
  Provider as SocketProvider,
} from './context/SocketContext';
import ResetPassword from './components/registrationForm/ResetPassword';
import Navbar from './components/globals/Navbar';
import SiteData from './config';
import AttendantLogin from './components/AttendantConsole/AttendantLogin';
import AttendantDashboard from './components/AttendantConsole/AttendantDashboard';
import AttendantTileEditor from './components/AttendantConsole/AttendantTileEditor';
import TabForm from './components/AttendantConsole/TabForm';
import NavbarAttendant from './components/globals/NavbarAttendant';
import ForgotPassword from './components/registrationForm/ForgotPassword';
import ClientLogin from './components/ClientConsole/ClientLogin';
import ClientDashboard from './components/ClientConsole/ClientDashboard';
import NavbarClient from './components/ClientConsole/NavbarClient';

import TabConsole from './components/AttendantConsole/TabConsole';
import AuditoriumPage from './pages/AuditoriumPage';
import { NotificationMessage } from './components/globals/NotificationMessage';
import {Socket,createSocket,heartbeat_msg,sendHeartbeat} from './api/expoHallSocket';
import EndofEventPage from './pages/EndofEventPage'
import LoadingPage from './pages/LoadingPage';

let heartbeat_interval = null;

const App = ({ className }) => {
  const [exhibitorData, setExhibitorData] = useState([]);

  const [loadGeneralChat, setLoadGeneralChat] = useState(false);
  const [loadTileChat, setLoadTileChat] = useState(false);
  const [missedHeartbeats, setMissedHeartbeats] = useState(0);
  const [attendantNavbarBackLink, setAttendantNavbarBackLink] = useState(
    '/auditorium'
  );
  const {
    state: {
      generalChatMessages,
      generalChatParticipants,
      tileChatMessages,
      tileChatParticipants,
    },
    setTileChatMessages,
    setTileChatParticipants,
    setGeneralChatMessages,
    setGeneralChatParticipants,
    setViewsNumber,
    setCategories,
    setLoadTileChatContext,
    setConnection,
  } = useContext(SocketContext);

  const generalChatMessagesRef = useRef(generalChatMessages);
  const generalChatParticipantsRef = useRef(generalChatParticipants);
  const tileChatMessagesRef = useRef(tileChatMessages);
  const tileChatParticipantsRef = useRef(tileChatParticipants);
  // useEffect(() => {
  //   getData();
  // }, []);

  // const getData = async () => {
  //   const { data } = await expoHallAPI.get(
  //     `/api/tiles/?timestamp=${new Date().getTime()}`
  //   );
  //   setExhibitorData(data);
  // };

  useLayoutEffect(() => {
    document.title = SiteData.titleIndex;
  }, []);

  useEffect(() =>{
    handleSocket();
  },[]);


  const handleHeartbeat =  () => {
    setMissedHeartbeats(0);
    heartbeat_interval  = setInterval(()=> {
      try {
        setMissedHeartbeats(prevState=> prevState+1);
        if (missedHeartbeats >= 3){
            throw new Error("Too many missed heartbeats.");
        }
        sendHeartbeat();
      } catch(e) {
        clearInterval(heartbeat_interval);
        heartbeat_interval = null;
        console.warn("Closing connection. Reason: " + e.message);
        Socket.close();
      }
    }, 5000);
  };

  const handleSocket = () => {
    createSocket();
    Socket.onmessage = (e) => {
      // console.log('message', e);
        socketActions(JSON.parse(e.data));
    };
    Socket.onopen = (e) => {
      console.log('open', e);
      setConnection(true);
      handleHeartbeat();

    };
    Socket.onerror = (e) => {
      console.log('error', e);
    };
    Socket.onclose = (e) => {
      setTimeout(()=>handleSocket(), 1000);
      setConnection(false);
      console.log('close', e);
    };
  };

  const socketActions = (data) => {
    switch (data.type) {
      case 'loadAllChatMessages':
        if (data.chatid === 1) {
          setGeneralChatMessages(data.messages);
          setGeneralChatParticipants(data.participants);
          setLoadGeneralChat(true);
          generalChatMessagesRef.current = data.messages;
          generalChatParticipantsRef.current = data.participants;
        } else {
          setTileChatMessages(data.messages);
          setTileChatParticipants(data.participants);
          setLoadTileChat(true);
          setLoadTileChatContext(true);
          tileChatMessagesRef.current = data.messages;
          tileChatParticipantsRef.current = data.participants;
        }
        break;
      case 'newParticipantChat':
        if (data.chatid === 1) {
          // generalChatParticipantsRef.current = generalChatParticipantsRef.current.concat(data.participants);
          // setGeneralChatParticipants(generalChatParticipantsRef.current);
          setGeneralChatParticipants(data.participants);
        } else {
          // tileChatParticipantsRef.current = tileChatParticipantsRef.current.concat(data.participants);
          // setTileChatParticipants(tileChatParticipantsRef.current);
          setTileChatParticipants(data.participants);
          if (data.views) {
            setViewsNumber(data.views);
          }
        }
        break;
      case 'participantLeftChat':
        if (data.chatid === 1) {
          // console.log(generalChatParticipantsRef.current)
          // generalChatParticipantsRef.current = generalChatParticipantsRef.current.concat(data.participants);
          // setGeneralChatParticipants(generalChatParticipantsRef.current);
        } else {
          if (data.views) {
            setViewsNumber(data.views);
          }
        }
        break;
      case 'loadMoreChatMessages':
        if (data.chatid === 1) {
          generalChatMessagesRef.current = data.messages.concat(
            generalChatMessagesRef.current
          );
          setGeneralChatMessages(generalChatMessagesRef.current);
        } else {
          tileChatMessagesRef.current = data.messages.concat(
            tileChatMessagesRef.current
          );
          setTileChatMessages(tileChatMessagesRef.current);
        }
        break;
      case 'newChatMessage':
        if (data.chatid === 1) {
          generalChatMessagesRef.current = generalChatMessagesRef.current.concat(
            data.message
          );
          setGeneralChatMessages(generalChatMessagesRef.current);
        } else {
          tileChatMessagesRef.current = tileChatMessagesRef.current.concat(
            data.message
          );
          setTileChatMessages(tileChatMessagesRef.current);
        }
        break;
      case 'toggleBooth':
        setCategories(data.categories);
        break;
      case 'heartbeat':
        if(heartbeat_msg === data.message){
          setMissedHeartbeats(0);
        }
        break;
      default:
      // code block
    }
  };

  return (
    <div className={className}>
      <GlobalStyles />
      <NotificationMessage />
      <UserProvider>
        <ExhibitorContext.Provider value={exhibitorData}>
          <AttendantProvider>
            <ClientProvider>
              <Router>
                <Switch>
                  <Route exact path="/">
                    {/* <Navbar /> */}
                    <SliderPage loadChat={loadGeneralChat} />
                  </Route>
                  {SiteData.auditorium && (
                    <Route exact path="/auditorium">
                      <AuditoriumPage />
                    </Route>
                  )}
                  {SiteData.auditorium && (
                    <Route exact path="/closing">
                      <EndofEventPage/>
                    </Route>
                  )}
                  <Route path="/login">
                    {/* <LoginForm /> */}
                    <RegistrationForm />
                  </Route>
                  <Route path="/register">
                    {' '}
                    <Register />{' '}
                  </Route>
                  <Route path="/forgotpassword">
                    {' '}
                    <ForgotPassword />{' '}
                  </Route>
                  <Route path="/reset/:uuid/:token">
                    {' '}
                    <ResetPassword />{' '}
                  </Route>
                  <Route exact path="/dashboard">
                    <NavbarAttendant
                      attendantNavbarBackLink={attendantNavbarBackLink}
                    />
                    <AttendantDashboard
                      setAttendantNavbarBackLink={setAttendantNavbarBackLink}
                      loadGeneralChat={loadGeneralChat}
                      loadTileChat={loadTileChat}
                    />
                  </Route>
                  <Route exact path="/editor">
                    <NavbarAttendant
                      attendantNavbarBackLink={attendantNavbarBackLink}
                    />
                    <AttendantTileEditor />
                  </Route>
                  <Route exact path="/tabs">
                    <NavbarAttendant
                      attendantNavbarBackLink={attendantNavbarBackLink}
                    />
                    <TabConsole />
                  </Route>
                  {/*<Route exact path="/attendantlogin">*/}
                  {/*<AttendantLogin />*/}
                  {/*</Route>*/}
                  <Route exact path="/client">
                    <NavbarClient />
                    <ClientDashboard />
                  </Route>
                  <Route path="/clientlogin">
                    <ClientLogin />
                  </Route>
                  <Route
                    exact
                    path="/loaderio-faafa801558db05beec16c6856f2516e"
                  />
                  <Route path="*" render={(props) => <div>Not found!</div>} />
                </Switch>
              </Router>
            </ClientProvider>
          </AttendantProvider>
        </ExhibitorContext.Provider>
      </UserProvider>
    </div>
  );
};

export default styled(App)`
  height: 100%;
  width: 100%;
`;
